import React from 'react';
import { withTheme } from 'styled-components';
import { Svg, Path } from 'react-native-svg';

const ExclamationMarkInCircle = ({
    className = '',
    size = '32',
    theme,
    color = theme.colors['Level 3'],
}) => (
    <Svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Path
            d="M16 2C8.26875 2 2 8.26875 2 16C2 23.7313 8.26875 30 16 30C23.7313 30 30 23.7313 30 16C30 8.26875 23.7313 2 16 2ZM16 27.625C9.58125 27.625 4.375 22.4188 4.375 16C4.375 9.58125 9.58125 4.375 16 4.375C22.4188 4.375 27.625 9.58125 27.625 16C27.625 22.4188 22.4188 27.625 16 27.625Z"
            fill={color}
        />
        <Path
            d="M14.5 21.5C14.5 21.8978 14.658 22.2794 14.9393 22.5607C15.2206 22.842 15.6022 23 16 23C16.3978 23 16.7794 22.842 17.0607 22.5607C17.342 22.2794 17.5 21.8978 17.5 21.5C17.5 21.1022 17.342 20.7206 17.0607 20.4393C16.7794 20.158 16.3978 20 16 20C15.6022 20 15.2206 20.158 14.9393 20.4393C14.658 20.7206 14.5 21.1022 14.5 21.5ZM15.25 18H16.75C16.8875 18 17 17.8875 17 17.75V9.25C17 9.1125 16.8875 9 16.75 9H15.25C15.1125 9 15 9.1125 15 9.25V17.75C15 17.8875 15.1125 18 15.25 18Z"
            fill={color}
        />
    </Svg>
);

export default withTheme(ExclamationMarkInCircle);
